/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';
import { AdCommunicatorEvents } from '../../../messaging';
import { Page } from '../../page';
import { Placement } from '../../placement';
import { AstPlacement } from './placement';

import type { CampaignData } from '../../../types';
import type { PrebidAdUnit } from '../../../types/prebid';
import type { SiteConfig } from '../../config';

const logger = Logger.getInstance();

class AstPage extends Page {
  private static astInstance: AstPage;

  private constructor(siteConfig: SiteConfig) {
    super(siteConfig);
  }

  public static getInstance(siteConfig: SiteConfig): AstPage {
    if (!AstPage.astInstance) {
      AstPage.astInstance = new AstPage(siteConfig);
    }
    return AstPage.astInstance;
  }

  protected createPlacement(
    adUnit: PrebidAdUnit,
    adUnitTransformer: (adUnitCode: string) => string,
    campaignData: CampaignData[],
    siteConfig: SiteConfig
  ): Placement {
    return new AstPlacement(adUnit, adUnitTransformer, campaignData, siteConfig);
  }

  protected locateContainingPlacement(event: {
    data: AdCommunicatorEvents['TaggedAdServed'];
  }): Placement | null {
    logger.info(`Locating containing placement for event: ${event}}`);
    return null;
  }
}

export { AstPage };
